import { lazy } from 'react'
import type { Routes } from '@/@types/routes'

const othersRoute: Routes = [
    {
        key: 'accessDenied',
        // Mounted at /admin/access-denied (OrganisationAllRoutes.tsx's
        // "/admin" + route.path); appConfig.accessDeniedPath is the single
        // source of truth AuthorityGuard.tsx redirects to.
        path: `/access-denied`,
        component: lazy(() => import('@/custolink-views/others/AccessDenied')),
        componentNewDesign: lazy(() => import('@/custolink-newdesign/pages/AccessDenied')),
        authority: [],
        meta: {
            pageBackgroundType: 'plain',
            pageContainerType: 'contained',
        },
    },
]

export default othersRoute
